// Copyright (c) 2016 Deere & Company

import './dealer-search-header.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const DealerSearchHeader = props =>
    <section className='dealer-search-header'>
        <div className='dealer-search-label'>
            <FormattedMessage id='DEALER_SEARCH'/>
        </div>
        <div className='dealer-search-button-group'>
            <button
                className='button-primary'
                onClick={props::props.onDealerSearchClick}
            >
                <FormattedMessage id='SEARCH'/>
            </button>
            <span className='cancel-dealer-search'/>
        </div>
    </section>;

DealerSearchHeader.displayName = 'DealerSearchHeader';
DealerSearchHeader.propTypes = {
    onDealerSearchClick: PropTypes.func.isRequired
};

export default DealerSearchHeader;




// WEBPACK FOOTER //
// ./src/product/dealer-search/components/dealer-search-header.js